import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Swal from "sweetalert2";

import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Navigate, useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { valueOf } from "../../../../assets/plugins/moment/src/lib/moment/to-type";

import SideBar from "../../SideBar";
import { API_URL } from "../../../../api/api";
export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const DisID = useLocation().pathname.split("/")[2];
  console.log(DisID, "ID");

  const [unitLists, setUnitLists] = useState([]);
  const [type, setType] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [treatLists, setTreatLists] = useState([]);

  const [conValue, setConValue] = useState("");

  const [value, setValue] = useState("");
  const [itemUnitName, setItemUnitName] = useState("");
  const [name, setName] = useState("");
  const [relatedBrand, setRelatedBrand] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [showValue, setShowValue] = useState(false);
  const [showItem, setShowItem] = useState(false);
  const [faceList, setFaceList] = useState([]);
  const [chooseFaceList, setChooseFaceList] = useState([]);

  const [showFace, setShowFace] = useState(false);
  const [bodyList, setBodyList] = useState([]);
  const [chooseBodyList, setChooseBodyList] = useState([]);

  const [showBody, setShowBody] = useState(false);
  const [bodyInjList, setBodyInjList] = useState([]);
  const [chooseBodyInjList, setChooseBodyInjList] = useState([]);

  const [showBodyInj, setShowBodyInj] = useState(false);
  const [chooseUnitList, setChooseUnitList] = useState([]);
  const [showUnit, setShowUnit] = useState(false);
  const [conName, setConName] = useState("");

  const [comPakList, setComPakList] = useState([]);
  const [chooseComPakList, setChooseComPakList] = useState([]);
  const [showComPak, setShowComPak] = useState(false);

  const [surgeryList, setSurgeryList] = useState([]);
  const [chooseSurgeryList, setChooseSurgeryList] = useState([]);
  const [showSurgery, setShowSurgery] = useState(false);
  const [fOCID, setFOCID] = useState("");
  const [disLists, setDisLists] = useState([]);
  const [treatmentName, setTreatmentName] = useState("");

  //For Con Type
  const handleConType = (name) => {
    setConName(name);
  };

  //for Unit List
  const handleUnit = (Id) => {
    console.log(Id, "Id");
    setChooseUnitList(
      unitLists.filter(
        (el) => (el.treatmentName ? el.treatmentName._id : "") == Id,
      ),
    );
    setShowUnit(true);
    console.log(
      unitLists.filter(
        (el) => (el.treatmentName ? el.treatmentName._id : "") == Id,
      ),
      "Final Unit List",
    );
  };
  //If FOCItem , Item
  const handleBodyPart = (event) => {
    console.log(event, "Body part");
    if (event == "Treatment") {
      setShowFace(true);
      setShowBody(false);
      setShowBodyInj(false);
      setShowComPak(false);
      setShowSurgery(false);

      setChooseFaceList(faceList);
    }
    if (event == "Hair,Combine Tre & Facial") {
      setShowBody(true);
      setShowFace(false);
      setShowBodyInj(false);
      setShowComPak(false);
      setShowSurgery(false);

      setChooseBodyList(bodyList);
    }

    if (event == "Injection") {
      setShowBody(false);
      setShowFace(false);
      setShowBodyInj(true);
      setChooseBodyInjList(bodyInjList);
      setShowComPak(false);
      setShowSurgery(false);
    }
    if (event == "Combination Package") {
      setShowBody(false);
      setShowFace(false);
      setShowBodyInj(false);
      setShowComPak(true);
      setShowSurgery(false);
      setChooseComPakList(comPakList);
    }
    if (event == "Surgery Price List") {
      setShowBody(false);
      setShowFace(false);
      setShowBodyInj(false);
      setShowComPak(false);
      setShowSurgery(true);
      setChooseSurgeryList(surgeryList);
    }
  };

  //Type
  const handleType = (event) => {
    setType(event);
    console.log(event, "Type");
    if (event == "Amount") {
      setShowValue(true);
      setShowItem(false);
    } else if (event == "Percent") {
      setShowValue(true);
      setShowItem(false);
    } else {
      setShowItem(true);
      setShowValue(false);
    }
  };

  //Create
  const DiscountUpdate = () => {
    const data = {
      id: DisID,
      name: name,
      startDate: startDate,
      endDate: endDate,
      type: type,
      description: description,
    };

    if (type == "FOCItem") {
      data.relatedFOCID = itemUnitName;
    } else {
      data.value = value;
    }
    if (conName == "Amount") data.conditionAmount = conValue;
    if (conName == "Purchase Freq") data.conditionPurchaseFreq = conValue;
    if (conName == "Package Qty") data.conditionPackageQty = conValue;

    alert(JSON.stringify(data));

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("discount", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Income Data!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        window.location.reload();
        // props.setDisLists([...props.disLists, response.data.data])
      })

      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Error",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  useEffect(() => {
    const getTreatmentList = async () => {
      try {
        const res = await api.get("treatment-lists");

        setTreatLists(res.data.list);
        console.log(res.data.list, "dialog treat list ");
        setFaceList(res.data.list.filter((el) => el.bodyParts == "Treatment"));
        setBodyList(
          res.data.list.filter(
            (el) => el.bodyParts == "Hair,Combine Tre & Facial",
          ),
        );
        setBodyInjList(
          res.data.list.filter((el) => el.bodyParts == "Injection"),
        );
        setComPakList(
          res.data.list.filter((el) => el.bodyParts == "Combination Package"),
        );
        setSurgeryList(
          res.data.list.filter((el) => el.bodyParts == "Surgery Price List"),
        );

        // console.log(
        //   res.data.list.filter(el => el.bodyParts == 'Body Injection'),
        //   'body inj list'
        // )
      } catch (err) {}
    };
    const getUnitList = async () => {
      try {
        const res = await api.get("treatments");

        setUnitLists(res.data.list);
        console.log(res.data.list, "unit list");
      } catch (err) {}
    };

    const getDiscount = async () => {
      try {
        const res = await api.get("discount/" + DisID);
        setDisLists(res.data.data);
        console.log(res.data.data, "dis list");
        setName(res.data.data[0].name);
        setType(res.data.data[0].type);
        if (res.data.data[0].type == "Amount" && "Percentage") {
          setValue(res.data.data[0].value);
          setShowValue(true);
          setShowItem(false);
        } else {
          if (res.data.data[0].relatedFOCID.treatmentName) {
            setTreatmentName(
              res.data.data[0].relatedFOCID.treatmentName
                ? res.data.data[0].relatedFOCID.treatmentName.bodyParts
                : "",
            );

            setItemUnitName(
              res.data.data[0].relatedFOCID.treatmentName
                ? res.data.data[0].relatedFOCID.treatmentName.name
                : "",
            );
            setShowItem(true);
            setShowValue(false);

            setShowUnit(true);
          }

          //   setShowValue(false)
          //   setShowUnit(false)
          //   setShowItem(true)
        }
        setFOCID(res.data.data[0].relatedFOCID);
        setStartDate(
          res.data.data[0].startDate
            ? res.data.data[0].startDate.split("T")[0]
            : "",
        );
        setEndDate(
          res.data.data[0].endDate
            ? res.data.data[0].endDate.split("T")[0]
            : "",
        );
        setDescription(
          res.data.data[0].description ? res.data.data[0].description : "",
        );
        if (res.data.data[0].conditionPurchaseFreq) {
          setConName("Purchase Freq");
          setConValue(res.data.data[0].conditionPurchaseFreq);
        } else if (res.data.data[0].conditionPackageQty) {
          setConName("Package Qty");
          setConValue(res.data.data[0].conditionPackageQty);
        } else {
          setConName("Amount");
          setConValue(res.data.data[0].conditionAmount);
        }
        // if (res.data.data[0].relatedFOCID.treatmentName.name) {
        //   console.log('success')

        //   //   setChooseUnitList(
        //   //     unitLists.filter(
        //   //       el => el._id == res.data.data[0].relatedFOCID.treatmentName._id
        //   //     )
        //   //   )

        //   setShowBody(true)
        // }
      } catch (err) {
        alert(err.message);
      }
    };
    getDiscount();
    getUnitList();

    getTreatmentList();
  }, []);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/discount">Back</Link>
                    </li>
                    <li className="breadcrumb-item active">Discount Update</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name">Name</label>
              <input
                type="text"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                defaultValue={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div class="form-group">
              <label for="name">Type</label>
              <select
                class="custom-select border-info"
                name="account_type_id"
                id="cat"
                onChange={(e) => handleType(e.target.value)}
              >
                <option value={type} hidden>
                  {type}
                </option>
                <option value="Amount">Amount</option>
                <option value="Percent">Percent</option>
                <option value="FOCItem">FOC Item</option>
              </select>
            </div>
            {showValue && (
              <div class="form-group">
                <label for="name">Value</label>
                <input
                  type="number"
                  class="form-control border border-info"
                  name="name"
                  placeholder="eg. mg mg"
                  defaultValue={value}
                  onChange={(e) => setValue(e.target.value)}
                />
              </div>
            )}
            {showItem && (
              <div class="form-group">
                <label for="name">Item</label>
                <select
                  class="custom-select border-info"
                  id="subCat"
                  name="account_type_id"
                  onChange={(e) => handleBodyPart(e.target.value)}
                >
                  <option hidden value={treatmentName}>
                    {treatmentName}
                  </option>

                  <option value="Treatment">Treatment</option>
                  <option value="Hair,Combine Tre & Facial">
                    Hair,Combine Tre & Facial
                  </option>
                  <option value="Injection">Injection</option>
                  <option value="Combination Package">
                    Combination Package
                  </option>

                  <option value="Surgery Price List">Surgery Price List</option>
                </select>
              </div>
            )}
            {showFace && (
              <div class="form-group">
                <label for="name">Choose Treatment Name</label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => handleUnit(e.target.value)}
                >
                  <option hidden>Choose Name</option>

                  {chooseFaceList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
              </div>
            )}
            {showBody && (
              <div class="form-group">
                <label for="name">Choose Treatment Name</label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => handleUnit(e.target.value)}
                >
                  <option hidden>Choose Name</option>

                  {chooseBodyList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
              </div>
            )}
            {showBodyInj && (
              <div class="form-group">
                <label for="name">Choose Treatment Name</label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => handleUnit(e.target.value)}
                >
                  <option hidden>Choose Name</option>

                  {chooseBodyInjList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
              </div>
            )}
            {showComPak && (
              <div class="form-group">
                <label for="name">Choose Treatment Name</label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => handleUnit(e.target.value)}
                >
                  <option hidden>Choose Name</option>

                  {chooseComPakList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
              </div>
            )}
            {showSurgery && (
              <div class="form-group">
                <label for="name">Choose Treatment Name</label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => handleUnit(e.target.value)}
                >
                  <option hidden>Choose Name</option>

                  {chooseSurgeryList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
              </div>
            )}

            {showUnit && (
              <div class="form-group">
                <label for="name">Choose Treatment Unit Name</label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => setItemUnitName(e.target.value)}
                >
                  <option value={itemUnitName} hidden>
                    {itemUnitName}
                  </option>

                  {chooseUnitList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
              </div>
            )}
            <div class="form-group">
              <label for="name">Condition Type</label>
              <select
                name="currency"
                id=""
                className="form-control mt-1"
                onchange="convert(this.value)"
                onChange={(e) => handleConType(e.target.value)}
              >
                <option hidden value={conName}>
                  {conName}
                </option>

                <option value="Amount">Amount</option>
                <option value="Purchase Freq">Purchase Freq</option>
                <option value="Package Qty">Package Qty</option>
              </select>
            </div>
            <div class="form-group">
              <label for="name">Condition Value</label>
              <input
                type="number"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                defaultValue={conValue}
                onChange={(e) => setConValue(e.target.value)}
              />
            </div>

            <div class="form-group">
              <label for="name">Start Date</label>
              <input
                type="date"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                defaultValue={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div class="form-group">
              <label for="name">End Date</label>
              <input
                type="date"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                defaultValue={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div class="form-group">
              <label for="name">Description</label>
              <textarea
                className="form-control"
                id="description"
                defaultValue={description}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <Link to="/discount" class="btn btn-secondary">
              Close
            </Link>
            <Button class="btn btn-primary" onClick={DiscountUpdate}>
              Save
            </Button>
          </div>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
// phyo
//maymyat
